import { Typography } from 'antd';
import { useEffect, useState } from 'react';

export function SpTypographyEditable({ text = '' }) {
  const [editableStr, setEditableStr] = useState('');

  useEffect(() => {
    setEditableStr(text);
  }, [text]);

  return <Typography.Paragraph editable={{ onChange: setEditableStr }}>{editableStr}</Typography.Paragraph>;
}
